import { DefaultTableSelectorOptions } from '@/models/i-table-selector';
import { Enrolment } from '@/models/enrolment';
import { IEnrolmentStepCounter } from '@/models/i-enrolment-counters';
import TableFilter from '@/presentation/components/generalizations/table-selectors/filters/table-filter';
import TableSelectorOption from '@/presentation/components/generalizations/table-selectors/table-selector-option';

export default class TableFilterStep extends TableFilter {
	get defaultOptions(): TableSelectorOption[] {
		return [
			new TableSelectorOption(
				DefaultTableSelectorOptions.DEFAULT,
				'All process steps',
				this.enrolmentsFilteredByOtherFilters.value.length
			)
		];
	}

	public createOptions(): TableSelectorOption[] {
		const stepCounters: IEnrolmentStepCounter[] = [];
		this.enrolmentsFilteredByOtherFilters.value.forEach((enrolment) => {
			const existingCounter = stepCounters.find((counter) => counter.step === enrolment.fulfillmentStep.fulfillmentStepIndication);
			if (existingCounter) {
				existingCounter.facet++;
				return;
			}

			stepCounters.push({
				label: enrolment.fulfillmentStep.name,
				step: enrolment.fulfillmentStep.fulfillmentStepIndication,
				facet: 1
			});
		});

		return stepCounters.map((counter) => new TableSelectorOption(counter.step, counter.label, counter.facet));
	}

	public doesEnrolmentMatchFilter(enrolment: Enrolment): boolean {
		const option = this.selectedOptionAsOption.value;
		if ((!option || option.isDefaultOption) && !this.selectedOption.value) {
			return true;
		}

		const step = enrolment.fulfillmentStep.fulfillmentStepIndication.toString();
		const selected = this.selectedOption.value.toString();
		return step === selected;
	}
}
